function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.902 43.817c-4.157.614-8.319.875-12.549-3.422l7.986-1.141c-3.79-.324-7.606-.562-10.267-4.563h6.844c-3.184-.08-5.972-1.252-7.985-4.564h6.845c-3.035-1.258-4.598-3.351-5.704-5.704 13.086 3.114 23.23 4.242 30.802 14.83 0 0-9.895-26.778-4.564-34.224 1.826-2.55 4.604-3.473 7.529-2.343C48.396 3.676 52 9.593 52 9.593l2.815 3c2.328 2.48-13.5-5.79-13.083-4.141-1.782.998-3.668 11.383 6.965 29.443 4.865 8.264.506 11.713-3.358 14.2-6.714 4.323-20.719 4.27-27.564-1.434-6.022-5.019-14.83-18.253-14.83-18.253h9.925",
  fill: "none",
  stroke: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 47.151,
  cy: 6.948,
  r: 0.525,
  fill: "none",
  stroke: "#000",
  strokeLinecap: "square",
  strokeWidth: 1.002
});

var SvgSwan = function SvgSwan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSwan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Swan.8f168dfc.svg";
export { ForwardRef as ReactComponent };